export const gitIntegrationSearchParams = {
  code: 'code',
  state: 'state',
  provider: 'provider',
};
